import { useTranslation } from "react-i18next";
import { ReactNode } from "react";
import defaultContent from "../../../content/earningsCalculator";
import LeafRectangleLoader from "../../../common/leaf/LeafLoadingSkeleton/LeafRectangleLoader/LeafRectangleLoader";
import LeafTile from "../../../common/leaf/LeafTile/LeafTile";
import "./EarningsCalculatorLoader.scss";
import { PageTitleSection } from "../../../common/components/PageTitleSection/PageTitleSection";

type Props = {
  isLoading: boolean;
  children?: ReactNode;
};

const EarningsCalculatorV2Loader = (props: Props) => {
  const { t } = useTranslation(["earningsCalculator", "common"]);
  const { isLoading, children } = props;

  if (isLoading === false) {
    return <>{children}</>;
  }

  return (
    <div className="earnings-calculator-loader">
      <div className="earnings-calculator-loader__header">
        <PageTitleSection title={`${t("pageTitle", defaultContent["pageTitle"])}`} hideTimeStamp />
        <div className="earnings-calculator-loader__header__toggle-switch">
          <LeafRectangleLoader isLoading={true} width={"100%"} height={"2rem"} />
        </div>
      </div>
      <div className="earnings-calculator-loader__content">
        <div className="earnings-calculator-loader__dashboard">
          <div className="earnings-calculator-loader__dashboard-content">
            <div className="earnings-calculator-loader__dashboard__metric">
              <div>
                {" "}
                <LeafRectangleLoader isLoading={true} numColumns={1} width="80%" height="1.5rem" />
              </div>
              <div>
                {" "}
                <LeafRectangleLoader isLoading={true} numColumns={1} width="60%" height="1.75rem" />
              </div>
            </div>
            <div className="earnings-calculator-loader__dashboard__metric">
              <div>
                {" "}
                <LeafRectangleLoader isLoading={true} numColumns={1} width="80%" height="1.5rem" />
              </div>
              <div>
                {" "}
                <LeafRectangleLoader isLoading={true} numColumns={1} width="60%" height="1.75rem" />
              </div>
            </div>
            <div className="earnings-calculator-loader__dashboard__metric">
              <div>
                {" "}
                <LeafRectangleLoader isLoading={true} numColumns={1} width="80%" height="1.5rem" />
              </div>
              <div>
                {" "}
                <LeafRectangleLoader isLoading={true} numColumns={1} width="60%" height="1.75rem" />
              </div>
            </div>
            <div className="earnings-calculator-loader__dashboard__metric">
              <div>
                {" "}
                <LeafRectangleLoader isLoading={true} numColumns={1} width="80%" height="1.5rem" />
              </div>
              <div>
                {" "}
                <LeafRectangleLoader isLoading={true} numColumns={1} width="60%" height="1.75rem" />
              </div>
            </div>
            <div className="earnings-calculator-loader__dashboard__metric">
              <div>
                {" "}
                <LeafRectangleLoader isLoading={true} numColumns={1} width="80%" height="1.5rem" />
              </div>
              <div>
                {" "}
                <LeafRectangleLoader isLoading={true} numColumns={1} width="60%" height="1.75rem" />
              </div>
            </div>
          </div>
        </div>
        <div className="earnings-calculator-loader__progress-tile">
          <div className="earnings-calculator-loader__progress-tile__reset">
            <LeafRectangleLoader isLoading={true} numColumns={1} width="100%" height="1.75rem" />
          </div>
          <div className="earnings-calculator-loader__progress-tile__container">
            <div className="earnings-calculator-loader__progress-tile__content">
              <div className="earnings-calculator-loader__progress-tile__heading">
                <div className="earnings-calculator-loader__progress-tile__heading-left">
                  <div>
                    <LeafRectangleLoader isLoading={true} numColumns={1} width="100%" height="1.75rem" />
                  </div>
                  <div>
                    <LeafRectangleLoader isLoading={true} numColumns={1} width="100%" height="1.5rem" />
                  </div>
                </div>

                <div>
                  <LeafRectangleLoader isLoading={true} numColumns={1} width="100%" height="3.5rem" />
                </div>
              </div>
              <div className="earnings-calculator-loader__progress-tile__slider">
                <LeafRectangleLoader isLoading={true} numColumns={1} width="100%" height="7.5rem" />
              </div>
            </div>
            <div className="earnings-calculator-loader__progress-tile__content">
              <div className="earnings-calculator-loader__progress-tile__heading">
                <div className="earnings-calculator-loader__progress-tile__heading-left">
                  <div>
                    <LeafRectangleLoader isLoading={true} numColumns={1} width="100%" height="1.75rem" />
                  </div>
                  <div>
                    <LeafRectangleLoader isLoading={true} numColumns={1} width="100%" height="1.5rem" />
                  </div>
                </div>

                <div>
                  <LeafRectangleLoader isLoading={true} numColumns={1} width="100%" height="3.5rem" />
                </div>
              </div>
              <div className="earnings-calculator-loader__progress-tile__slider">
                <LeafRectangleLoader isLoading={true} numColumns={1} width="100%" height="7.5rem" />
              </div>
            </div>
          </div>
        </div>
        <div className="earnings-calculator-loader__abo-legs">
          <div className="earnings-calculator-loader__abo-legs__header">
            <div className="earnings-calculator-loader__abo-legs__title">
              <h5>{`${t("aboLegs.title", defaultContent["aboLegs"]["title"])}`}</h5>
              <div className="earnings-calculator-loader__abo-legs__title-loader">
                <LeafRectangleLoader isLoading={true} width={"100%"} height={"2rem"} />
              </div>
            </div>

            <div className="earnings-calculator-loader__abo-legs__nav-tabs">
              <LeafRectangleLoader isLoading={true} width={"100%"} height={"2.25rem"} />
              <LeafRectangleLoader isLoading={true} width={"100%"} height={"2.25rem"} />
            </div>
          </div>
          <div className="earnings-calculator-loader__abo-legs__content">
            <div className="earnings-calculator-loader__abo-legs__content__card">
              <LeafTile
                isLoading={true}
                rectangleLoaderNumColumns={1}
                rectangleLoaderNumRows={1}
                rectangleLoaderHeightPerLine={"10.5rem"}
              />
            </div>
            <div className="earnings-calculator-loader__abo-legs__content__card">
              <LeafTile
                isLoading={true}
                rectangleLoaderNumColumns={1}
                rectangleLoaderNumRows={1}
                rectangleLoaderHeightPerLine={"10.5rem"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EarningsCalculatorV2Loader;
